import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import {
  ArticleGroupIds,
  ArticleCategory,
  ArticleBrandId,
  ArticleStatus,
} from "entities/manageArticles/types";
import { FC } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import DropdownList, {
  DropdownListItemProps,
} from "shared/components/DropdownList";
import { MANAGE_ARTICLE_DETAILS_PATH } from "shared/routes/paths";
import { useArticleGroupPage } from "../../context";

type Props = {
  params: GridRenderCellParams;
};

const TableDropdown: FC<Props> = ({ params }) => {
  const { brandId, categoryId, groupId } = useParams();
  const { handleUpdatingArticleStatus, onOpenDeletingArticleModal } =
    useArticleGroupPage();
  const navigate = useNavigate();

  const { row } = params;

  const statusTitle =
    row.status === ArticleStatus.PUBLISHED ? "Unpublish" : "Publish";

  const isActive = row.status === ArticleStatus.PUBLISHED;

  const items = [
    {
      title: "Edit",
      onClick: () =>
        navigate(
          generatePath(MANAGE_ARTICLE_DETAILS_PATH, {
            brandId: brandId as ArticleBrandId,
            categoryId: categoryId as ArticleCategory,
            groupId: groupId as ArticleGroupIds,
            id: row.id,
          }),
        ),
    },
    {
      title: statusTitle,
      onClick: () => {
        handleUpdatingArticleStatus({
          articleId: row.id,
          status: isActive
            ? ArticleStatus.UNPUBLISHED
            : ArticleStatus.PUBLISHED,
          language: params.row.language,
        });
      },
    },
    !isActive
      ? {
          title: "Delete",
          style: "remove",
          onClick: () => onOpenDeletingArticleModal(row.id),
        }
      : null,
  ].filter((item) => item !== null) as DropdownListItemProps[];

  return <DropdownList items={items} />;
};

export default TableDropdown;
